// extracted by mini-css-extract-plugin
module.exports = {"SelectHolder":"ShopArticleSort_SelectHolder__38fe0"};